export const GET_TABLE_DATA = '[TABLES] GET_TABLE_DATA';
export const SET_TABLE_SORTER = '[TABLES] SET_TABLE_SORTER';
export const CLEAR_TABLE_DATA = '[TABLES] CLEAR_TABLE_DATA';
